import { render } from "./default_button.vue?vue&type=template&id=57bdd929"
import script from "./default_button.vue?vue&type=script&lang=js"
export * from "./default_button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__